const expertiseItems = [
  {
    label: 'iOS Platform Engineering',
    bgClass: 'bg-accent-100',
    patternClass: 'bg-accent-200/60',
  },
  {
    label: 'System Architecture',
    bgClass: 'bg-secondary-100',
    patternClass: 'bg-secondary-200/60',
  },
  {
    label: 'Performance Optimization',
    bgClass: 'bg-primary-100',
    patternClass: 'bg-primary-200/50',
  },
  {
    label: 'User-Centered Design',
    bgClass: 'bg-accent-50',
    patternClass: 'bg-accent-200/50',
  },
];

export default function ExpertiseSection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.15em] text-foreground-500 mb-4">
            Core Competencies
          </p>
          <h3 className="text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight tracking-tight">
            Areas of
            <br />
            expertise
          </h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertiseItems.map((item) => (
            <div
              key={item.label}
              className="rounded-2xl overflow-hidden group"
            >
              <div className={`relative h-64 md:h-72 ${item.bgClass}`}>
                <div
                  className={`absolute inset-6 rounded-xl ${item.patternClass}`}
                />
                <div className="absolute inset-8 rounded-lg border border-foreground-200/20">
                  <svg
                    className="w-full h-full opacity-20"
                    viewBox="0 0 200 200"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <pattern
                        id={`grid-${item.label.replace(/\s+/g, '')}`}
                        width="20"
                        height="20"
                        patternUnits="userSpaceOnUse"
                      >
                        <circle cx="10" cy="10" r="1" fill="currentColor" />
                      </pattern>
                    </defs>
                    <rect
                      width="200"
                      height="200"
                      fill={`url(#grid-${item.label.replace(/\s+/g, '')})`}
                    />
                    <line
                      x1="40"
                      y1="60"
                      x2="160"
                      y2="60"
                      stroke="currentColor"
                      strokeWidth="0.5"
                    />
                    <line
                      x1="40"
                      y1="100"
                      x2="160"
                      y2="100"
                      stroke="currentColor"
                      strokeWidth="0.5"
                    />
                    <line
                      x1="40"
                      y1="140"
                      x2="160"
                      y2="140"
                      stroke="currentColor"
                      strokeWidth="0.5"
                    />
                    <line
                      x1="80"
                      y1="40"
                      x2="80"
                      y2="160"
                      stroke="currentColor"
                      strokeWidth="0.5"
                    />
                    <line
                      x1="120"
                      y1="40"
                      x2="120"
                      y2="160"
                      stroke="currentColor"
                      strokeWidth="0.5"
                    />
                  </svg>
                </div>
              </div>
              <div className="bg-background-50 px-5 py-4">
                <p className="text-sm md:text-base font-medium text-foreground-800">
                  {item.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}